import { AssemblersFiltersType } from '@components/users/assemblers/AssemblersFilter'
import { makeFilter, makeSearchFilter } from './crud/filters'
import { NestedFilter } from '@@partner:types:graphql'


export const prepareAssemblerFilter = (filters: AssemblersFiltersType): NestedFilter => {
  const idFilter = makeFilter('id', 'eq', filters.id)
  const firstNameFilter = makeSearchFilter('first_name', 'includes', filters.name)
  const lastNameFilter = makeSearchFilter('last_name', 'includes', filters.name)
  const phoneFilter = makeFilter('phone', 'eq', filters.phone)
  const statusFilter = makeFilter(
    'status',
    'contains',
    filters.status?.map(String)
  )
  const shopIdsFilter = makeFilter('shop_id', 'contains', filters.shopIds)

  return {
    and: [
      idFilter,
      {
        or: [
          firstNameFilter,
          lastNameFilter
        ],
      },
      phoneFilter,
      statusFilter,
      shopIdsFilter
    ]
  }
}